import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { SendEmployeeEmail, GetEmailLogs } from "helpers/api_method";

export const sendEmployeeEmail = createAsyncThunk("email/sendEmployeeEmail", async (event: any) => {
    try {
        const response = await SendEmployeeEmail(event);
        return response.data;
    } catch (error: any) {
        throw error;
    }
});

export const getEmailLogs = createAsyncThunk("email/getEmailLogs", async (params?: any) => {
    try {
        const response = await GetEmailLogs(params);
        return response.data;
    } catch (error: any) {
        throw error;
    }
});
